export class IMeshalem
{
    ms_zehut_mazmin:number;
    id_nofesh:number;
    ms_zehut_meshalem:number
    ms_zehut_meshalem_previous:number;
    ms_chadarim :number
    schum:number
    ofen_tashlum:number;
    ms_tashlumim:number;
    nofesh_title:string
    nofesh_from:string
    nofesh_to:string;
    shem_prati_meshalem: string;
    shem_mishpacha_meshalem: string;

    constructor(){
        this.ms_zehut_mazmin = 0;
        this.id_nofesh = 0;
        this.ms_zehut_mazmin = 0;
        this.ms_zehut_meshalem = 0;
        this.ms_zehut_meshalem_previous = 0;
        this.ms_chadarim = 0
        this.schum = 0
        this.ofen_tashlum = 0;
        this.ms_tashlumim = 0;
        this.nofesh_title = "";
        this.nofesh_from = ""
        this.nofesh_to = "";
        this.shem_prati_meshalem = ""
        this.shem_mishpacha_meshalem = "";
    
        
    }
}